import { Trainers } from "./pages/Trainers";
import { TrainerCreate } from "./pages/TrainerCreate";
import { TrainerEdit } from "./pages/TrainerEdit";

export const trainersRoutes = [
  {
    path: "/mobileApps/:appId/trainers",
    component: Trainers,
    exact: true,
  },
  {
    path: "/mobileApps/:appId/trainers/create",
    component: TrainerCreate,
    exact: true,
  },
  {
    path: "/mobileApps/:appId/trainers/edit/:trainerId",
    component: TrainerEdit,
    exact: true,
  },
] as const;
